import { render, staticRenderFns } from "./AlarmSeting.vue?vue&type=template&id=954490b6&scoped=true&"
import script from "./AlarmSeting.vue?vue&type=script&lang=js&"
export * from "./AlarmSeting.vue?vue&type=script&lang=js&"
import style0 from "./AlarmSeting.vue?vue&type=style&index=0&id=954490b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954490b6",
  null
  
)

export default component.exports